import * as React from "react";
import * as ReactDOM from "react-dom";
import { Label } from "./";

interface IProperties
{
    /**
     * Enthält alle Child-Elemente.
     */
    children?: JSX.Element | JSX.Element[],

    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,
}

export class LabelContainer extends React.Component<IProperties>
{
    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        const { children, style } = this.props;

        return (
            <div
                className="label-container"
                style={style}>
                {children}
            </div>
        );
    }
}